import _ from "lodash";

export type Status =
  | "paid"
  | "posted"
  | "payment_due"
  | "not_paid"
  | "voided"
  | "pending";

export const statuses: Status[] = [
  "paid",
  "posted",
  "payment_due",
  "not_paid",
  "voided",
  "pending",
];

export const selectStatuses = statuses.map((status) => {
  return { value: status, label: status.replaceAll("_", " ").toUpperCase() };
});

export const colorsByStatus: Record<Status, string> = {
  paid: "green",
  posted: "gray",
  payment_due: "orange",
  not_paid: "yellow",
  voided: "red",
  pending: "cyan",
};
